<script setup>
import { ModalsContainer } from 'vue-final-modal'
</script>
<template>
  <div>
    <div
      v-if="loading"
      class="h-screen w-full flex justify-center items-center"
    >
      <DotLoader :fillColor="'#006FFF'" />
    </div>
    <div v-else>
      <PiemanContainer
        v-if="
          $config.public.piemanSupport &&
          authStore.getAuthUser &&
          (authStore.getAuthUser?.group == 'Ben_free' || authStore.getAuthUser?.group == 'Ben_paid')
        "
      />
      <vue3-confirm-dialog></vue3-confirm-dialog>
      <NuxtLoadingIndicator />
      <div
        class="flex flex-col mx-auto lg:border-b border-gray-100 mt-3 lg:mt-0 z-50 bg-SharesquareBackground"
      >
        <div
          class="flex items-center justify-between h-14 p-3 md:justify-between w-full"
        >
          <div
            v-if="isMobileView && !showSideBar"
            class="mr-2"
            @click="toggleMenu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="blue"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
              />
            </svg>
          </div>
          <div
            v-if="isMobileView && showSideBar"
            class="mr-2"
            @click="toggleMenu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="blue"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />
            </svg>
          </div>
          <NuxtLink to="/">
            <Logo />
          </NuxtLink>
          <div
            v-if="!isMobileView"
            class="w-full flex items-center justify-end px-2 space-x-6"
          >
            <!-- <elevio-element
              v-if="authStore.getAuthUser"
              data-type="search"
            ></elevio-element> -->
            <div
              class="h-8 flex items-center cursor-pointer"
              @click="bookMeeting"
            >
              <CalendarIcon class="h-8 mr-2 text-SharesquareBlue" />
              {{ $t('BOOK_A_MEETING') }}
            </div>
            <LayoutDropDownMenu />
          </div>
          <div
            v-else
            class="w-full flex items-center justify-end px-2 space-x-6"
          >
            <div
              class="h-8 flex items-center cursor-pointer"
              @click="bookMeeting"
            >
              <CalendarIcon class="h-8 mr-2 text-SharesquareBlue" />
            </div>
            <LayoutDropDownMenu />
          </div>
        </div>
      </div>
      <div v-if="isMobileView" class="w-full items-center justify-center">
        <!-- <elevio-element v-if="false" data-type="search"></elevio-element> -->
      </div>

      <div class="flex flex-row flex-grow custom-h-150vh">
        <transition name="slide">
          <div
            v-if="showSideBar || !isMobileView"
            class="flex flex-row flex-grow h-full"
          >
            <Sidebar />
          </div>
        </transition>
        <LayoutContentContainer>
          <NuxtPage />
        </LayoutContentContainer>
      </div>
      <div
        class="flex items-center justify-center flex-col w-full md:flex-row p-3 bg-gray-50 text-right fixed bottom-0"
      >
        <p
          class="font-light text-center md:text-left text-gray-500 text-xs md:mb-0"
        >
          {{ $t('COMPONENT_LAYOUT_FOOTER_COPYRIGHT') }}
          {{ $moment().format('YYYY') }}.
          {{ $t('COMPONENT_LAYOUT_FOOTER_RIGHTS') }}
        </p>
        <div class="flex text-xs font-light md:ml-auto">
          <ul class="flex flex-row">
            <li
              class="text-SharesquareBlueDark mr-2 hover:opacity-80 cursor-pointer"
              @click="openDoc('documents-terms-and-conditions')"
            >
              {{ $t('COMPONENT_LAYOUT_FOOTER_TERMS') }}
            </li>
            <li
              class="text-SharesquareBlueDark mr-2 hover:opacity-80 cursor-pointer"
              @click="openDoc('documents-privacy-policy')"
            >
              {{ $t('COMPONENT_LAYOUT_FOOTER_PRIVACY') }}
            </li>
            <li
              class="text-SharesquareBlueDark hover:opacity-80 cursor-pointer"
              @click="openDoc('documents-cvd')"
            >
              {{ $t('COMPONENT_LAYOUT_FOOTER_CVD') }}
            </li>
          </ul>
        </div>
      </div>

      <ModalsContainer />
    </div>
  </div>
</template>

<script>
import { CalendarIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '~/store/auth/state'

export default {
  components: {
    CalendarIcon,
  },
  data() {
    return {
      authStore: useAuthStore(),
      showSideBar: false,
      loading: true,
    }
  },
  computed: {
    isMobileView() {
      return window.innerWidth < 832 ? true : false
    },
  },
  mounted() {
    this.$nuxt.onConsent()
  },
  async beforeCreate() {
    await new Promise((resolve) => setTimeout(resolve, 2000))
    this.loading = false
  },
  methods: {
    bookMeeting() {
      this.$router.push(
        `/create-plan-wizard/${
          this.$route.params.id || 'new'
        }/meetings?articleId=204`
      )
    },
    toggleMenu() {
      this.showSideBar = !this.showSideBar
    },
    openDoc(dest) {
      this.$router.push({ name: dest })
    },
  },
}
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.1s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-to {
  transform: translateX(15%);
}
.slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  transform: translateX(-100%);
}
.custom-h-150vh {
  height: 150vh;
}
</style>
